<template>
  <div v-if="show" class="cm-overlay">
    <div class="cm-box">
      <div class="cm-icon" :class="danger ? 'cm-icon-danger' : 'cm-icon-warn'">
        <fa-icon :icon="icon" />
      </div>
      <h5 class="cm-title">{{ title }}</h5>
      <p class="cm-msg">
        <slot>{{ message }}</slot>
      </p>
      <div class="cm-actions">
        <app-button variant="ghost" size="md" :disabled="loading" style="flex:1" @click="$emit('confirm')">
          <fa-icon v-if="loading" :icon="['fas', 'spinner']" spin />
          {{ loading ? loadingLabel : confirmLabel }}
        </app-button>
        <app-button :variant="danger ? 'danger' : 'primary'" size="md" :disabled="loading" style="flex:1" @click="$emit('cancel')">{{ cancelLabel }}</app-button>
      </div>
    </div>
  </div>
</template>

<script>
import bodyScrollLockMixin from '@/mixins/bodyScrollLockMixin'
import AppButton from './AppButton.vue'

export default {
  name: 'ConfirmModal',
  components: { AppButton },
  mixins: [bodyScrollLockMixin],
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: 'Are you sure?' },
    message: { type: String, default: '' },
    icon: { type: Array, default: () => ['fas', 'exclamation-circle'] },
    confirmLabel: { type: String, default: 'Confirm' },
    cancelLabel: { type: String, default: 'Cancel' },
    loadingLabel: { type: String, default: 'Processing…' },
    danger: { type: Boolean, default: true },
    loading: { type: Boolean, default: false }
  }
}
</script>
